import { MapContainer, TileLayer, Circle, Marker, useMapEvents, useMap } from "react-leaflet";
import { useEffect } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default marker icons (webpack asset paths)
const markerIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

function ClickHandler({ onPick }) {
  useMapEvents({
    click(e) {
      if (onPick) onPick(e.latlng.lat, e.latlng.lng);
    },
  });
  return null;
}

function Recenter({ lat, lng }) {
  const map = useMap();
  useEffect(() => {
    if (lat && lng) map.setView([lat, lng]);
  }, [lat, lng, map]);
  return null;
}

const BAND_COLORS = ["#0066FF", "#06B6D4", "#f59e0b", "#8b5cf6", "#10b981"];

export default function ServiceMap({
  depot, serviceRadiusKm, bands = [], point = null, height = 360, onPick = null,
}) {
  if (!depot) return null;
  const center = [depot.lat, depot.lng];
  const sorted = [...bands].sort((a, b) => b.max_km - a.max_km);

  return (
    <div className="rounded-2xl overflow-hidden border border-slate-200" style={{ height }} data-testid="service-map">
      <MapContainer center={center} zoom={10} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {onPick && <ClickHandler onPick={onPick} />}
        <Recenter lat={depot.lat} lng={depot.lng} />

        {/* service radius outline */}
        <Circle center={center} radius={serviceRadiusKm * 1000}
          pathOptions={{ color: "#0B192C", weight: 2, fillOpacity: 0.04, dashArray: "6 6" }} />

        {/* pricing bands as concentric fills */}
        {sorted.map((b, i) => (
          <Circle key={b.id || i} center={center} radius={b.max_km * 1000}
            pathOptions={{ color: BAND_COLORS[(sorted.length - 1 - i) % BAND_COLORS.length],
              weight: 1, fillOpacity: 0.10 }} />
        ))}

        <Marker position={center} icon={markerIcon} />
        {point && point.lat && (
          <Marker position={[point.lat, point.lng]} icon={markerIcon} />
        )}
      </MapContainer>
    </div>
  );
}
